import { Col, Row } from "react-bootstrap";
import { useState, useRef, useEffect } from 'react';
import { Button, Input, Space, Table, Card, Form, Popconfirm, Typography, InputNumber, Modal, Empty } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Highlighter from 'react-highlight-words';
import { useSelector, useDispatch } from 'react-redux'
import { v4 } from 'uuid'
import {
    getObjective, setMemberFail, getMemberFail, setMemberSuccess, getMemberSuccess, getBizID, getStyle, getFile, getFileID, getServices
} from '../../../../libs/todoSlice'
import LoadingComponent from "../../../../lib/LoadingComponent";
import axios from "axios";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useNavigate, useParams } from 'react-router-dom';
import fontColor from "../../../../lib/fontColor";
import { getModalBeforeSuccessRedux, setModalBeforeSuccessRedux, getModalNoteRedux, setModalNoteRedux, getLoadingRedux, setLoadingRedux, getNoteTXTRedux, setNoteTXTRedux } from "../../../../libs/addFailSlice";


//function edit table
const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        // {
                        //   required: true,
                        //   message: `Please Input ${title}!`,
                        // },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};
//end function edit table

const AddStudentFail = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const memberSuccess = useSelector(getMemberSuccess)
    const memberOneFail = useSelector(getMemberFail)
    const file = useSelector(getFile)
    const objective = useSelector(getObjective)
    const services = useSelector(getServices)
    const business_id = useSelector(getBizID)
    const style = useSelector(getStyle)
    const typeTemplate = useSelector(getObjective)
    // const [modalbeforeSuccess, setModalBeforeSuccess] = useState(false);
    // const [ modalNote, setModalNote ] = useState(false)
    // const [ loading, setLoading ] = useState(false)
    // const [ noteTXT, setNoteTXT ] = useState([])

    const modalbeforeSuccess = useSelector(getModalBeforeSuccessRedux)
    const setModalBeforeSuccess = (action) => {
        dispatch(setModalBeforeSuccessRedux({
            modalbeforeSuccess: action
        }))
    }

    const modalNote = useSelector(getModalNoteRedux)
    const setModalNote = (action) => {
        dispatch(setModalNoteRedux({
            modalNote: action
        }))
    }

    const loading = useSelector(getLoadingRedux)
    const setLoading = (action) => {
        dispatch(setLoadingRedux({
            loading: action
        }))
    }

    const noteTXT = useSelector(getNoteTXTRedux)
    const setNoteTXT = (action) => {
        dispatch(setNoteTXTRedux({
            noteTXT: action
        }))
    }

    const keyNote = {
        'The first name eng format is invalid.': 'Format ชื่อภาษาอังกฤษไม่ถูกต้อง',
        'The first name th format is invalid.': 'Format ชื่อภาษาไทยไม่ถูกต้อง',
        'The last name eng format is invalid.': 'Format นามสกุลภาษาอังกฤษไม่ถูกต้อง',
        'The last name th format is invalid.': 'Format นามสกุลภาษาไทยไม่ถูกต้อง',
        'The selected account title th is invalid.': 'คำนำหน้าไม่ถูกต้อง',

        'account_title_eng Invalid value': 'คำนำหน้าภาษาอังกฤษไม่ถูกต้อง',
        'account_title_th Invalid value': 'คำนำหน้าภาษาไทยไม่ถูกต้อง',
        'title_en is not match': 'คำนำหน้าภาษาอังกฤษไม่สอดคล้องกัน',
        'title_th is not match': 'คำนำหน้าภาษาไทยไม่สอดคล้องกัน',
        'email Invalid value': 'Email ไม่ถูกต้อง',
        'email duplicate': 'Email ซ้ำกับในระบบ',
        'mobile_no Invalid value': 'เบอร์มือถือไม่ถูกต้อง',
        'first_name_eng Invalid value': 'ชื่อภาษาอังกฤษไม่ถูกต้อง',
        'first_name_th Invalid value': 'ชื่อภาษาไทยไม่ถูกต้อง',
        'last_name_eng Invalid value': 'นามสกุลภาษาอังกฤษไม่ถูกต้อง',
        'last_name_th Invalid value': 'นามสกุลภาษาไทยไม่ถูกต้อง',
        'id_card_num Invalid value': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
        'id_card_num is incorrect': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
        'special_title_th Invalid value': 'คำนำหน้านามภาษาไทยไม่ถูกต้อง',
        'special_title_eng Invalid value': 'คำนำหน้านามภาษาอังกฤษไม่ถูกต้อง',
        'position Invalid value': 'ตำแหน่งไม่ถูกต้อง',
        'employee_id Invalid value': 'เลขประจำตัวบุคลากรทางการแพทย์ไม่ถูกต้อง',
        'The mobile no may not be greater than 10 characters.': 'หมายเลขโทรศัพท์มือถือต้องมีความยาวไม่เกิน 10 ตัวอักษร',
        'The username format is invalid.': 'เกิดข้อผิดพลาดในการตั้ง username',
        'Thai Email Cannot Created': 'เกิดข้อผิดพลาดในการสร้างอีเมล',
        'id card duplicated': 'เลขบัตรประชาชนซ้ำในระบบ',
        'student_id Invalid value': 'เลขประจำตัว นักเรียน/บุคลากร ไม่ถูกต้อง',
        "zipcode can't match": 'รหัสไปรษณีย์ไม่ถูกต้อง',
        'status Invalid value': 'สถานะไม่ถูกต้อง',
        'start_year Invalid value': 'วันที่เริ่มต้นไม่ถูกต้อง',
        'end_year Invalid value': 'วันที่สิ้นสุดไม่ถูกต้อง',
        'This account_id has not been username.': 'มี account อยู่แล้ว แต่ยังไม่ตั้ง username กรุณาตั้ง username แล้วอัพโหลดอีกครั้ง',
        'tel Invalid value': 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        'cid is incorrect': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
        'district Invalid value': 'อำเภอไม่ถูกต้อง',
        'province Invalid value': 'จังหวัดไม่ถูกต้อง',
        'sub_district Invalid value': 'ตำบลไม่ถูกต้อง',
        "zipcode Cast to Number failed for value \NaN\(type number)at path\zipcode\for model\zipcodes": 'รหัสไปรษณีย์ไม่ถูกต้อง',
        "zipcode Cast to Number failed for value \\NaN\\ (type number) at path \\zipcode\\ for model \\zipcodes\\": 'รหัสไปรษณีย์ไม่ถูกต้อง',
        'zipcode Cast to Number failed for value \NaN\(type number)at path\zipcode\for model\zipcodes': 'รหัสไปรษณีย์ไม่ถูกต้อง',
        'start year Invalid value': 'วันที่เริ่มต้นการศึกษาไม่ถูกต้อง',
        'student_id is duplicated': 'รหัสนักศึกษา/บุคลากร มีซ้ำในระบบ',
        'name_th Invalid value': 'ชื่อ (ภาษาไทย) ไม่ถูกต้อง',
        'title_th Invalid value': 'คำนำหน้า (ภาษาไทย) ไม่ถูกต้อง',
        'birth_date Invalid value': 'วันเกิด ไม่ถูกต้อง',
        'name_eng Invalid value': 'ชื่อ (ภาษาอังกฤษ) ไม่ถูกต้อง',
        'title_en Invalid value': 'คำนำหน้า (ภาษาอังกฤษ) ไม่ถูกต้อง',
        'surname_eng Invalid value': 'นามสกุล (ภาษาอังกฤษ) ไม่ถูกต้อง',
        'surname_th Invalid value': 'นามสกุล (ภาษาไทย) ไม่ถูกต้อง',
        "cid Cannot read properties of undefined (reading 'length')": 'ความยาวของหมายเลขบัตรประชาชนไม่ถูกต้อง',
        "The username must be at least 6 characters.": 'ความยาวของชื่อภาษาอังกฤษไม่เพียงพอต่อการ generate username',

        // 'This user is already in the business.': 'Username นี้ มีอยู่ใน Business นี้แล้ว',
    }

    const alertManagement = () => {

        let message = `One ID`
        if (objective.includes('CA') || objective.includes('import-excel-rama')) {
            message += ', CA'
        }
        if (objective.includes('เลขที่หนังสือสัญญา')) {
            message += ' และเลขที่หนังสือสัญญา'
        }

        if (objective.includes('edu-student-pre-register')) {
            message = 'ข้อมูล Pre Registration สำหรับ นักเรียน/นักศึกษา'
        }

        if (objective.includes('edu-teacher-pre-register')) {
            message = 'ข้อมูล Pre Registration สำหรับ ครู/อาจารย์'
        }
        if (objective.includes('Pre-register')) {
            message = 'ข้อมูล Pre Registration สำหรับบุคคลากรทางการแพทย์'
        }

        if (memberSuccess.length !== 0) {
            return (
                <>
                    สร้าง {message} แล้ว {memberSuccess.length} รายการ จาก {file.length} รายการ
                </>
            )
        } else {
            return (
                <>
                    ไม่มีการสร้าง {message}
                </>
            )
        }

    }

    const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
    const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
    const title_special_th_list = ['นายแพทย์', 'แพทย์หญิง', 'ทันตแพทย์ชาย', 'ทันตแพทย์หญิง', 'เภสัชกรหญิง', 'เภสัชกรชาย']
    const title_special_en_list = ['DR.(Male)', 'DR.(Female)', 'D.D.S.(Male)', 'D.D.S.(Female)', 'female pharmacist', 'male pharmacist']
    const subject = {
        'rama': 'rama',
        'pmuc': 'pmuc',
    }
    const callAgain = async () => {
        let prepare_data = [...data]
        let success = []
        let success_key = []
        let fail = []
        let fail_key = []
        for await (const key of stateBtnAgain.reverse()) {
            setLoading(true)
            let request = memberOneFail.filter((member, index) => {
                if (member.request.key === key) {
                    prepare_data[index].loading = true
                    setData(prepare_data)
                    return true
                } else {
                    prepare_data[index].loading = false
                    setData(prepare_data)
                    return false
                }
            })
            if (request.length !== 0) {
                request = request[0].request
                const title_en = title_en_list[title_th_list.indexOf(request.title_th)]
                const call = () => new Promise((resolve, reject) => {
                    axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/create-account-oneid`,
                        data: {
                            account_title_th: request.title_th,
                            first_name_th: request.name_th,
                            last_name_th: request.surname_th,
                            account_title_eng: title_en,
                            first_name_eng: request.name_eng,
                            last_name_eng: request.surname_eng,
                            id_card_num: request.cid ? request.cid.toString().replaceAll(' ', '').replaceAll('-', '') : null,
                            email: request.email ? request.email.toString().replaceAll(' ', '') : null,
                            mobile_no: request.mobile ? request.mobile.toString().replaceAll(' ', '') : null,
                            biz_id: business_id,
                            objective: objective,
                            subject: subject[services.includes('import-excel-rama') ? 'rama' : 'pmuc'],
                            contract_no: objective.includes('เลขที่หนังสือสัญญา') ? request.contract_no : null
                        }
                    }).then(({ data, status }) => {
                        setLoading(false)
                        if (status !== 204) {
                            success.push({ request: request, response: data })
                            success_key.push(key)
                            setTimeout(() => {
                                resolve()
                            }, 500);
                        }
                    }, ({ response }) => {
                        setLoading(false)
                        fail.push({ request: request, response: response.data })
                        fail_key.push(key)
                        setTimeout(() => {
                            resolve()
                        }, 500);
                    })
                })
                await call()
            }
        }
        let success_summary = [...memberSuccess, ...success]
        let fail_summary = [...member_fail.filter(member => {
            return !success_key.includes(member.request.key)
        }).map((member, indexes) => {
            if (fail_key.includes(member.request.key)) {
                let inner_member = { ...member }
                inner_member.request = fail[fail_key.indexOf(member.request.key)].request
                inner_member.response = fail[fail_key.indexOf(member.request.key)].response
                return inner_member
            } else {
                return member
            }
        })]
        sendExcelSummary(success_summary, fail_summary)
        dispatch(setMemberSuccess({
            member_success: success_summary
        }))
        dispatch(setMemberFail({
            member_fail: fail_summary
        }))
        setStateBtnAgain([])
        setLoading(false)
        setModalBeforeSuccess(true)
    }
    const callAgainPreregister = async () => {
        let prepare_data = [...data]
        let success = []
        let success_key = []
        let fail = []
        let fail_key = []
        for await (const key of stateBtnAgain.reverse()) {
            setLoading(true)
            let request = memberOneFail.filter((member, index) => {
                if (member.request.key === key) {
                    prepare_data[index].loading = true
                    setData(prepare_data)
                    return true
                } else {
                    prepare_data[index].loading = false
                    setData(prepare_data)
                    return false
                }
            })
            if (request.length !== 0) {
                request = request[0].request
                const title_en = title_en_list[title_th_list.indexOf(request.title_th)]
                const title_special_en = title_special_en_list[title_special_th_list.indexOf(request.title_special_th)]
                const call = () => new Promise((resolve, reject) => {
                    axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/doctor/preregister`,
                        data: {
                            employee_id: request.employee_id.toString(),
                            account_title_th: request.title_th,
                            special_title_th: request.title_special_th,
                            first_name_th: request.name_th,
                            last_name_th: request.surname_th,
                            account_title_eng: title_en,
                            special_title_eng: title_special_en,
                            first_name_eng: request.name_eng,
                            last_name_eng: request.surname_eng,
                            id_card_num: request.cid.toString(),
                            email: request.email,
                            mobile_no: request.mobile ?? request.tel,
                            biz_id: business_id,
                            address: request.address,
                            position: request.position,
                            contract_no: objective.includes('เลขที่หนังสือสัญญา') ? request.contract_no : null
                        }
                    }).then(({ data, status }) => {
                        setLoading(false)
                        if (status !== 204) {
                            success.push({ request: request, response: data })
                            success_key.push(key)
                            setTimeout(() => {
                                resolve()
                            }, 500);
                        }
                    }, ({ response }) => {
                        setLoading(false)
                        fail.push({ request: request, response: response.data })
                        fail_key.push(key)
                        setTimeout(() => {
                            resolve()
                        }, 500);
                    })
                })
                await call()
            }
        }
        let success_summary = [...memberSuccess, ...success]
        let fail_summary = [...member_fail.filter(member => {
            return !success_key.includes(member.request.key)
        }).map((member, indexes) => {
            if (fail_key.includes(member.request.key)) {
                let inner_member = { ...member }
                inner_member.request = fail[fail_key.indexOf(member.request.key)].request
                inner_member.response = fail[fail_key.indexOf(member.request.key)].response
                return inner_member
            } else {
                return member
            }
        })]
        sendExcelSummary(success_summary, fail_summary)
        dispatch(setMemberSuccess({
            member_success: success_summary
        }))
        dispatch(setMemberFail({
            member_fail: fail_summary
        }))
        setStateBtnAgain([])
        setLoading(false)
        setModalBeforeSuccess(true)
    }
    const callAgainEduStudentPreregister = async () => {
        let prepare_data = [...data]
        let success = []
        let success_key = []
        let fail = []
        let fail_key = []
        for await (const key of stateBtnAgain.reverse()) {
            setLoading(true)
            let request = memberOneFail.filter((member, index) => {
                if (member.request.key === key) {
                    prepare_data[index].loading = true
                    setData(prepare_data)
                    return true
                } else {
                    prepare_data[index].loading = false
                    setData(prepare_data)
                    return false
                }
            })
            if (request.length !== 0) {
                request = request[0].request
                // const title_en = title_en_list[title_th_list.indexOf(request.title_th)]


                let title_en = request.title_en
                if (!request.title_en) {
                    title_en = title_en_list[title_th_list.indexOf(request.title_th)]
                }
                let title_th = request.title_th
                if (!request.title_th) {
                    title_th = title_th_list[title_en_list.indexOf(request.title_en)]
                }
                const call = () => new Promise((resolve, reject) => {
                    axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/education/student/pre-register`,
                        data: {
                            account_title_eng: title_en,
                            title_en: title_en,
                            title_th: title_th,
                            biz_id: business_id,
                            ...request
                        }
                    }).then(({ data, status }) => {
                        setLoading(false)
                        if (status !== 204) {
                            success.push({ request: request, response: data })
                            success_key.push(key)
                            setTimeout(() => {
                                resolve()
                            }, 500);
                        }
                    }, ({ response }) => {
                        setLoading(false)
                        fail.push({ request: request, response: response.data })
                        fail_key.push(key)
                        setTimeout(() => {
                            resolve()
                        }, 500);
                    })
                })
                await call()
            }
        }
        let success_summary = [...memberSuccess, ...success]
        let fail_summary = [...member_fail.filter(member => {
            return !success_key.includes(member.request.key)
        }).map((member, indexes) => {
            if (fail_key.includes(member.request.key)) {
                let inner_member = { ...member }
                inner_member.request = fail[fail_key.indexOf(member.request.key)].request
                inner_member.response = fail[fail_key.indexOf(member.request.key)].response
                return inner_member
            } else {
                return member
            }
        })]
        sendExcelSummary(success_summary, fail_summary)
        dispatch(setMemberSuccess({
            member_success: success_summary
        }))
        dispatch(setMemberFail({
            member_fail: fail_summary
        }))
        setStateBtnAgain([])
        setLoading(false)
        setModalBeforeSuccess(true)
    }
    const callAgainEduTeacherPreregister = async () => {
        let prepare_data = [...data]
        let success = []
        let success_key = []
        let fail = []
        let fail_key = []
        for await (const key of stateBtnAgain.reverse()) {
            setLoading(true)
            let request = memberOneFail.filter((member, index) => {
                if (member.request.key === key) {
                    prepare_data[index].loading = true
                    setData(prepare_data)
                    return true
                } else {
                    prepare_data[index].loading = false
                    setData(prepare_data)
                    return false
                }
            })
            if (request.length !== 0) {
                request = request[0].request
                const title_en = title_en_list[title_th_list.indexOf(request.title_th)]
                const title_special_en = title_special_en_list[title_special_th_list.indexOf(request.title_special_th)]
                const call = () => new Promise((resolve, reject) => {
                    axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/education/teacher/pre-register`,
                        data: {
                            account_title_eng: title_en,
                            title_en: title_en,
                            special_title_eng: title_special_en,
                            biz_id: business_id,
                            ...request
                        }
                    }).then(({ data, status }) => {
                        setLoading(false)
                        if (status !== 204) {
                            success.push({ request: request, response: data })
                            success_key.push(key)
                            setTimeout(() => {
                                resolve()
                            }, 500);
                        }
                    }, ({ response }) => {
                        setLoading(false)
                        fail.push({ request: request, response: response.data })
                        fail_key.push(key)
                        setTimeout(() => {
                            resolve()
                        }, 500);
                    })
                })
                await call()
            }
        }
        let success_summary = [...memberSuccess, ...success]
        let fail_summary = [...member_fail.filter(member => {
            return !success_key.includes(member.request.key)
        }).map((member, indexes) => {
            if (fail_key.includes(member.request.key)) {
                let inner_member = { ...member }
                inner_member.request = fail[fail_key.indexOf(member.request.key)].request
                inner_member.response = fail[fail_key.indexOf(member.request.key)].response
                return inner_member
            } else {
                return member
            }
        })]
        sendExcelSummary(success_summary, fail_summary)
        dispatch(setMemberSuccess({
            member_success: success_summary
        }))
        dispatch(setMemberFail({
            member_fail: fail_summary
        }))
        setStateBtnAgain([])
        setLoading(false)
        setModalBeforeSuccess(true)
    }

    // function show member to fail table
    useEffect(() => {
        
        let prepareData = memberOneFail.map((members, index) => {
            let title_en = members.request.title_en
            if (!members.request.title_en) {
                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                title_en = title_en_list[title_th_list.indexOf(members.request.title_th)]
            }
            return {
                key: members.request.key,
                loading: false,
                index: index,
                // index: members.request.index,
                contract_no: members.request.contract_no,
                title_th: members.request.title_th,
                title_en: title_en,
                name_th: members.request.name_th,
                surname_th: members.request.surname_th,
                name_eng: members.request.name_eng,
                surname_eng: members.request.surname_eng,
                cid: members.request.cid,
                address: members.request.address,
                tel: members.request.tel,
                mobile: members.request.mobile,
                email: members.request.email,
                position: members.request.position,
                sub_organization: members.request.sub_organization,
                organization: members.request.organization,
                tax_id: members.request.tax_id,
                maintainer_name_1: members.request.maintainer_name_1,
                maintainer_surname_1: members.request.maintainer_surname_1,
                maintainer_name_2: members.request.maintainer_name_2,
                maintainer_surname_2: members.request.maintainer_surname_2,
                maintainer_email_1: members.request.maintainer_email_1,
                maintainer_email_2: members.request.maintainer_email_2,
                maintainer_tel_1: members.request.maintainer_tel_1,
                maintainer_tel_2: members.request.maintainer_tel_2,
                id_card_type: members.request.id_card_type,
                response: members.response,
                room_no: members.request.room_no,
                house_no: members.request.house_no,
                moo: members.request.moo,
                floor: members.request.floor,
                street: members.request.street,
                building_name: members.request.building_name,
                alley: members.request.alley,
                start_year: members.request.start_year,
                end_year: members.request.end_year,
                status: members.request.status,
                student_id: members.request.student_id,
                username: members.request.username,
                password: members.request.password,
                faculty: members.request.faculty,
                sub_district: members.request.sub_district,
                district: members.request.district,
                zipcode: members.request.zipcode,
                province: members.request.province,
                nickname_th: members.request.nickname_th,
                nickname_eng: members.request.nickname_eng,
                birth_date: members.request.birth_date,
            }
        })
        setData(prepareData)
        setDataDefault(prepareData)
    }, [memberOneFail])
    // end function show member to fail table
    //function edit table
    const member_fail = useSelector(getMemberFail)
    useEffect(() => {
        setData(member_fail.map((member, index) => {
            return {
                ...member.request,
                index: index + 1,
                // key: v4(),
                loading: false,
            }
        }))
    }, [member_fail]);

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [dataDefault, setDataDefault] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        form.setFieldsValue({
            index: '',
            contract_no: '',
            title_th: '',
            name_th: '',
            surname_th: '',
            name_eng: '',
            surname_eng: '',
            cid: '',
            address: '',
            // sub_district: '',
            // district: '',
            // province: '',
            // zipcode: '',
            tel: '',
            mobile: '',
            email: '',
            position: '',
            sub_organization: '',
            // organization:'',
            // tax_id:'',
            // maintainer_name_1:'',
            // maintainer_surname_1:'',
            // maintainer_name_2:'',
            // maintainer_surname_2:'',
            // maintainer_email_1:'',
            // maintainer_email_2:'',
            // maintainer_tel_1:'',
            // maintainer_tel_2:'',
            // name: '',
            // age: '',
            ...record,
        });
        setEditingKey(record.key);
    };
    const cancel = () => {
        setEditingKey('');
    };
    const save = async (key, not_set = false) => {
        setStateBtnAgain([])
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => {
                return key === item.index
            });
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
                setData(newData);
                dispatch(setMemberFail({
                    member_fail: memberOneFail.map((member, fail_index) => {
                        return {
                            request: fail_index === index ? newData[index] : member.request,
                            response: member.response
                        }
                    })
                }))
                if (!not_set) {
                    setEditingKey('');
                }
            } else {
                newData.push(row);
                setData(newData);
                if (!not_set) {
                    setEditingKey('');
                }
            }
        } catch (errInfo) {
        }
    };
    // function delete
    const handleDelete = (key) => {
        const newData = data.filter((item) => item.key !== key);
        setData(newData);
        dispatch(setMemberFail({
            member_fail: [...newData.map((item) => {
                return {
                    request: item,
                    response: item.response
                }
            })]
        }))
    };
    // end function delete

    // function search
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });
    // end search
    const columns = [
        {
            title: 'ลำดับที่',
            dataIndex: 'index',
            width: 100,
            show: true,
            render: (__, _, index) => __,
            // render: (__, _, index) => parseInt(index) + 1,
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาไทย)</>),
            dataIndex: 'title_th',
            width: 150,
            show: true,
            // width: '10%',
            // editable: true,
            // ...getColumnSearchProps('title_th'),
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="title_th">คำนำหน้า</InputLabel>
                        <Select
                            value={record.title_th}
                            labelId='title_th'
                            label="คำนำหน้า"
                            onChange={(e) => {
                                let tempData = [...data]
                                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                                const title_en = title_en_list[title_th_list.indexOf(e.target.value)]
                                tempData[record.index - 1].title_th = e.target.value
                                tempData[record.index - 1].title_en = title_en
                                setData(tempData)
                            }}
                        >
                            <MenuItem value={'นาย'}>นาย</MenuItem>
                            <MenuItem value={'นางสาว'}>นางสาว</MenuItem>
                            <MenuItem value={'นาง'}>นาง</MenuItem>
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'เด็กชาย'}>เด็กชาย</MenuItem>
                                )
                            }
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'เด็กหญิง'}>เด็กหญิง</MenuItem>
                                )
                            }

                        </Select>
                    </FormControl>
                ) : (record.title_th)
            }
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'title_en',
            width: 150,
            show: true,
            // width: '10%',
            // editable: true,
            // ...getColumnSearchProps('title_th'),
            render: (_, record, index) => {
                let show = ''
                if (!_) {
                    let tempData = [...data]
                    const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                    const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                    const title_en = title_en_list[title_th_list.indexOf(record.title_th)]
                    show = title_en
                } else {
                    show = _
                }
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="title_en">คำนำหน้า (ภาษาอังกฤษ)</InputLabel>
                        <Select
                            value={show}
                            labelId='title_en'
                            label="ภาษาอังกฤษ"
                            onChange={(e) => {
                                let tempData = [...data]
                                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                                const title_th = title_th_list[title_en_list.indexOf(e.target.value)]
                                tempData[index].title_en = e.target.value
                                tempData[index].title_th = title_th
                                setData(tempData)
                            }}
                        >
                            <MenuItem value={'Mr'}>Mr</MenuItem>
                            <MenuItem value={'Miss'}>Miss</MenuItem>
                            <MenuItem value={'Mrs'}>Mrs</MenuItem>
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'Master'}>Master</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                ) : (show)
            }
        },
        {
            title: (<>คำนำหน้าอื่นๆ <br />(ภาษาไทย)</>),
            dataIndex: 'special_title_th',
            width: 150,
            show: objective.includes('edu-teacher-pre-register') || objective.includes('edu-student-pre-register'),
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>คำนำหน้าอื่นๆ <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'special_title_eng',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>ชื่อ <br />(ภาษาไทย)</>),
            dataIndex: 'name_th',
            width: 150,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>ชื่อกลาง <br />(ภาษาไทย)</>),
            dataIndex: 'middle_name_th',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>นามสกุล <br />(ภาษาไทย)</>),
            dataIndex: 'surname_th',
            width: 150,
            // width: '10%',
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('surname_th'),
        },
        {
            title: (<>ชื่อ <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'name_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: (<>ชื่อกลาง <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'middle_name_eng',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>นามสกุล <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'surname_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('surname_eng'),
        },
        {
            title: 'ประเภทบัตร',
            dataIndex: 'id_card_type',
            width: 180,
            show: objective.includes('edu-student-pre-register') || objective.includes('edu-teacher-pre-register'),
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="id_card_type">ประเภทบัตร</InputLabel>
                        <Select
                            value={record.id_card_type}
                            labelId='id_card_type'
                            label="ประเภทบัตร"
                            onChange={(e) => {
                                record.id_card_type = e.target.value;
                                save(record.index, true)
                            }}
                        >
                            <MenuItem value={'ID_CARD'}>ID_CARD</MenuItem>
                            <MenuItem value={'PASSPORT'}>PASSPORT</MenuItem>
                            <MenuItem value={'G_CODE'}>G_CODE</MenuItem>
                        </Select>
                    </FormControl>
                ) : (record.id_card_type)
            }
        },
        {
            title: 'เลขประจำตัวประชาชน',
            dataIndex: 'cid',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'ระดับการศึกษา',
            dataIndex: 'degree',
            width: 150,
            editable: true,
            show: objective.includes('edu-student-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'คณะ',
            dataIndex: 'faculty',
            width: 150,
            editable: true,
            show: objective.includes('edu-student-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'Major (สาขา/ภาควิชา)',
            dataIndex: 'major',
            width: 150,
            editable: true,
            show: objective.includes('edu-student-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'Minor (ถ้ามี)',
            dataIndex: 'minor',
            width: 150,
            editable: true,
            show: objective.includes('edu-student-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'สถานะการศึกษา',
            dataIndex: 'status',
            width: 180,
            // editable: true,
            show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="status">คำนำหน้า</InputLabel>
                        <Select
                            value={record.status}
                            labelId='status'
                            label="คำนำหน้า"
                            onChange={(e) => {
                                record.status = e.target.value;
                                save(record.index, true)
                            }}
                        >
                            <MenuItem value={'กำลังศึกษา'}>กำลังศึกษา</MenuItem>
                            <MenuItem value={'สำเร็จการศึกษา'}>สำเร็จการศึกษา</MenuItem>
                            <MenuItem value={'ลาออก'}>ลาออก</MenuItem>
                            <MenuItem value={'พ้นสภาพการศึกษา'}>พ้นสภาพการศึกษา</MenuItem>
                            <MenuItem value={'อื่นๆ'}>อื่นๆ</MenuItem>
                        </Select>
                    </FormControl>
                ) : (record.status)
            }
        },
        {
            title: 'รหัสนักเรียน/บุคลากร ',
            dataIndex: 'student_id',
            width: 150,
            editable: true,
            show: objective.includes('edu-student-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },

        {
            title: 'วันเกิด',
            dataIndex: 'birth_date',
            width: 150,
            editable: true,
            show: objective.includes('edu-student-pre-register') || objective.includes('Pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },

        {
            title: 'วันที่เริ่มการศึกษา',
            dataIndex: 'start_year',
            width: 150,
            editable: true,
            // show: objective.includes('edu-student-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'วันที่จบการศึกษา',
            dataIndex: 'end_year',
            width: 150,
            editable: true,
            // show: objective.includes('edu-student-pre-register'),
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'โทรศัพท์',
            dataIndex: 'tel',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('tel'),
        },
        {
            title: 'อีเมล',
            dataIndex: 'email',
            width: 250,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('email'),
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            show: true,
            fixed: 'right',
            width: 200,
            render: (_, record, index) => {
                const editable = isEditing(record);
                return record.loading ? <LoadingComponent width={80} height={80} /> : editable ? (
                    <span>
                        <Button
                            type='primary'
                            disabled={loading}
                            onClick={() => save(record.index)}
                            style={{
                                marginRight: 8,
                                background: '#53BE35'
                            }}
                        >
                            บันทึก
                        </Button>
                        <Popconfirm title="Sure to cancel?" disabled={loading} onConfirm={cancel}>
                            ยกเลิก
                        </Popconfirm>
                    </span>
                ) : (
                    <>
                        <Typography.Link disabled={editingKey !== '' || loading} onClick={() => edit(record)}>
                            <ModeEditOutlinedIcon style={{ color: style.primary_color ?? '#053075', }} />
                        </Typography.Link> &nbsp;
                        {data.length >= 1 ? (
                            <Popconfirm title="ต้องการลบข้อมูลนี้ใช่หรือไม่?"
                                disabled={loading}
                                // disabled
                                onConfirm={() =>
                                    handleDelete(record.key)
                                }>
                                <DeleteOutlinedIcon style={{ color: 'red', cursor: 'pointer' }} />
                            </Popconfirm>
                        ) : null(services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'))
                        }
                        &nbsp;
                        <Button size='large'
                            disabled={loading}
                            style={{ backgroundColor: '#F8F9FA', color: '#053075' }}
                            onClick={() => {
                                // setStateBtnAgain([])

                                let prepare = []
                                setModalNote(true)
                                if (typeof (memberOneFail[index].response.message) !== 'string') {
                                    if (memberOneFail[index].response.message instanceof Array) {
                                        for (const key of memberOneFail[index].response.message) {
                                            prepare.push(key)
                                        }
                                    } else {
                                        for (const key in memberOneFail[index].response.message) {
                                            prepare.push(memberOneFail[index].response.message[key])
                                        }
                                    }
                                    setNoteTXT(prepare)
                                } else {
                                    if (memberOneFail[index].response.message === 'ID card is incorrect') {
                                        setNoteTXT(['หมายเลขบัตรประจำตัวประชาชนไม่ถูกต้อง'])
                                    } else if (memberOneFail[index].response.message === 'This user is already in the business.') {
                                        setNoteTXT(['ชื่อนี้มีอยู่ใน Business แล้ว'])
                                    } else if (memberOneFail[index].response.message === 'email duplicate') {
                                        setNoteTXT(['Email นี้มีอยู่ในระบบแล้ว'])
                                    } else if (memberOneFail[index].response.message === 'The Email cannot using.') {
                                        setNoteTXT(['Email นี้ไม่มีอยู่จริง'])
                                    } else if (memberOneFail[index].response.message === 'This account_id has not been username.') {
                                        setNoteTXT(['มี account อยู่แล้ว แต่ยังไม่ตั้ง username กรุณาตั้ง username แล้วอัพโหลดอีกครั้ง'])
                                    }
                                }
                            }}>

                            หมายเหตุ
                        </Button>
                    </>
                );
            },
        },
    ].filter(head => head.show);
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ||
                    col.dataIndex === 'index' ||
                    col.dataIndex === 'no' ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    // end edit table
    // start select row
    const [stateBtnAgain, setStateBtnAgain] = useState([]);
    const rowSelection = {
        selectedRowKeys: stateBtnAgain,
        onChange: (selectedRowKeys, selectedRows) => {
            setStateBtnAgain(selectedRowKeys)
        },
        getCheckboxProps: (selectedRowKeys) => {
            return {
                // Column configuration not to be checked
                key: selectedRowKeys.key,
                disabled: loading
            }
        }
        ,
    };
    // end select row
    // start search top

    // end searct top
    // function add fail or success to history
    const fileID = useSelector(getFileID)
    const successList = useSelector(getMemberSuccess)
    const params = useParams()
    const failList = useSelector(getMemberFail)
    const sendExcelSummary = async (success, fail) => {
        await axios({
            method: 'PATCH',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
            data: {
                _id: fileID,
                total: `${file.length}`,
                success: `${success.length}`,
                fail: `${fail.length}`,
                successDetail: successList,
                objective: objective,
                failDetail: failList
            }
        }).then(({ data, status }) => {

        }, ({ response }) => {
            const { status } = response
            if (status === 401) {
                navigate(`/${params.prefix}`)
            }
        })
    }
    // end add data to history

    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };
    return (
        <>
            <Row>
                {/* <Col className="d-flex justify-content-start" xl={5} lg={6} md={6} sm={12} xs={12}>
          <Input.Group compact>
                <h5>ค้นหา</h5>
                <Input
                  value={searchParam}
                  allowClear
                  size="large"
                  style={{
                    width: 'calc(100% - 40px)',
                  }}
                  placeholder="ค้นหาด้วยชื่อ-นามสกุล(ภาษาไทย) หรือ เลขบัตรประจำตัวประชาชน"
                  onChange={({target}) => {
                    setSearchParam(target.value);
                  }}
                  onPressEnter={()=>{
                    searchName()
                  }}
                  maxLength={100}
                />
                <Button 
                icon={<SearchOutlined />} 
                size="large" 
                style={{borderRadius:'0px 4px 4px 0px'}}
                onClick={()=>{
                  searchName()
                }}
                />
              </Input.Group>
          </Col> */}
                <Col className="d-flex justify-content-end">
                    {stateBtnAgain.length !== 0 &&
                        <>
                            <Button
                                style={{
                                    borderColor: style.secondary_color ?? '#053075',
                                    color: '#000000',
                                    marginRight: '3px'
                                }}
                                onClick={() => {
                                    let prepareData = data.filter(data => !stateBtnAgain.includes(data.key))
                                    let prepareDataFail = member_fail.filter(data => !stateBtnAgain.includes(data.request.key))
                                    setData(prepareData)
                                    dispatch(setMemberFail({
                                        member_fail: prepareDataFail
                                    }))

                                    setStateBtnAgain([])
                                }}
                            >
                                ลบ
                            </Button>
                            <Button
                                type="primary"
                                style={{
                                    background: style.secondary_color ?? '#053075',
                                    color: style.secondary_color ? fontColor(style.secondary_color) : '#FFFFFF'
                                }}
                                disabled={loading}
                                onClick={() => {
                                    if (objective.includes('Pre-register')) {
                                        Promise.resolve(callAgainPreregister()).then(() => {

                                        })
                                    }
                                    else if (objective.includes('edu-student-pre-register')) {
                                        Promise.resolve(callAgainEduStudentPreregister()).then(() => {

                                        })
                                    }
                                    else if (objective.includes('edu-teacher-pre-register')) {
                                        Promise.resolve(callAgainEduTeacherPreregister()).then(() => {

                                        })
                                    }
                                    else {
                                        Promise.resolve(callAgain()).then(() => {

                                        })
                                    }
                                }}>
                                <AutorenewIcon /> ดำเนินการสร้างอีกครั้ง
                            </Button>
                        </>
                    }

                </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                {/* ui table */}
                <Form form={form} component={false}>
                    <Table
                        locale={customLocale}
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        bordered
                        dataSource={data}
                        columns={mergedColumns}
                        rowClassName="editable-row"
                        pagination={{
                            onChange: cancel,
                        }}
                        scroll={{
                            x: 1400,
                            y: 400,
                        }}
                        rowSelection={{
                            type: 'checkbox',
                            // ...rowSelection,
                            ...rowSelection
                        }}
                    />
                </Form>
                {/* end ui table */}
            </Row>
            {/* modal หมายเหตุ */}
            <Modal
                title="หมายเหตุ"
                centered
                open={modalNote}
                footer={null}
                onCancel={() => setModalNote(false)}
            >
                {noteTXT.map((notes) => {
                    let show = notes instanceof Array ? keyNote[notes] : notes
                    if (!show) {
                        show = notes
                    }
                    return (
                        notes &&
                        (
                            <span>
                                <ul>
                                    <li>
                                        {JSON.stringify(show).replaceAll('"', '')}
                                    </li>
                                </ul>
                            </span>
                        )
                    )
                })}
            </Modal>
            {/* end modal หมายเหตุ */}
            {/* modal success */}
            <Modal
                title={memberSuccess.length !== 0 ? "ทำรายการสำเร็จ" : "ทำรายการไม่สำเร็จ"}
                centered
                open={modalbeforeSuccess}
                onOk={() => setModalBeforeSuccess(false)}
                onCancel={() => setModalBeforeSuccess(false)}
                footer={null}
            >
                <Row>
                    <Col className='d-flex justify-content-center'>
                        {memberSuccess.length !== 0 ?
                            <CheckIcon style={{
                                background: '#53BE35',
                                borderRadius: '50%',
                                fontSize: '50px',
                                color: '#fff',
                                padding: '10px'
                            }} />
                            :
                            <CloseIcon style={{
                                background: '#F37959',
                                borderRadius: '50%',
                                fontSize: '50px',
                                color: '#fff',
                                padding: '10px'
                            }} />
                        }
                    </Col>
                </Row>
                <Row style={{ paddingTop: '30px', paddingBottom: '30px' }}>
                    <Col className='d-flex justify-content-center'>
                        {alertManagement()}
                    </Col>
                </Row>
            </Modal>
        </>
    )
}
export default AddStudentFail